import { createSlice } from '@reduxjs/toolkit'
import { deleteSites, editSites, getSitesById, getSitesList, getSitesPage, postSites } from '../action/sitesAction'

const initialState = {
  dataSites: [],
  dataByIdSites: [],
  dataSitesList: [],
  idSites: '',
  state: '',
  isOpenFormSites: false,
  isLoading: false,
}
const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenFormSites = action.payload.open
      state.state = action.payload.state
      if (action.payload.type === 'close') {
        state.dataByIdSites = []
        state.idSites = ''
      }
      if (action.payload.state === 'edit') {
        state.dataByIdSites = action.payload.data
        state.idSites = action.payload.id
      } else if (action.payload.state === 'delete') {
        state.dataByIdSites = action.payload.data
        state.idSites = action.payload.id
      }
    },
  },
  extraReducers: {
    [getSitesPage.pending]: (state) => {
        state.isLoading = true
    },
    [getSitesPage.fulfilled]: (state, action) => {
        // console.log(action.payload.data);
        state.dataSites = action.payload.data
        state.isLoading = false
    },
    [getSitesPage.rejected]: (state) => {
        state.isLoading = false
    },
    [getSitesById.pending]: (state) => {
      state.isLoading = true
    },
    [getSitesById.fulfilled]: (state, action) => {
      // console.log(action.payload)
      state.dataByIdSites = action.payload.data
      state.isLoading = false
    },
    [getSitesById.rejected]: (state) => {
      state.isLoading = false
    },
    [getSitesList.pending]: (state) => {
      state.isLoading = true
    },
    [getSitesList.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataSitesList = action.payload.data
      state.isLoading = false
    },
    [getSitesList.rejected]: (state) => {
      state.isLoading = false
    },
    [postSites.pending]: (state) => {
      state.isLoading = true
    },
    [postSites.fulfilled]: (state, action) => {
      state.isOpenFormSites = false
      state.isLoading = false
    },
    [postSites.rejected]: (state) => {
      state.isLoading = false
    },
    [editSites.pending]: (state) => {
      state.isLoading = true
    },
    [editSites.fulfilled]: (state, action) => {
      state.isOpenFormSites = false
      state.isLoading = false
      state.dataByIdSites = []
      state.idData = 0
    },
    [editSites.rejected]: (state) => {
      state.isLoading = false
    },
    [deleteSites.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteSites.fulfilled]: (state, action) => {
      state.isOpenFormSites = false;
      state.isLoading = false;
      state.dataByIdSites = [];
      state.idSites = 0;
    },
    [deleteSites.rejected]: (state) => {
      state.isLoading = false;
    },
  },
})

export const { openForm } = sitesSlice.actions
export default sitesSlice.reducer
